export const ActiveChatInRoomStyle = (theme) => ({
  container: {
    maxWidth: "800px",
    margin: "0px auto 20px",
    padding: "0px 10px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,

    "@media (max-width: 800px)": {},
  },

  balanceContainer: {
    display: "flex",
    justifyContent: "space-between",
    background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
    border: "2px solid #ff6b35",
    borderRadius: "0px",
    padding: "16px 20px",
    boxShadow: "0 4px 12px rgba(255, 107, 53, 0.2)",
    backdropFilter: "blur(10px)",
    color: "#ffffff",
    fontWeight: "500",
  },

  balanceInnerLeft: {
    flex: "1",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& b": {
      color: "#ffffff",
      fontSize: "14px",
      fontWeight: "600",
    }
  },

  balanceInnerLeftValue: {
    color: "#ff6b35",
    fontWeight: "700",
    fontSize: "16px",
    textShadow: "0 0 8px rgba(255, 107, 53, 0.3)",
  },

  balanceInnerRightValue: {
    color: "#ffffff",
    fontWeight: "700",
    fontSize: "16px",
    textShadow: "0 0 8px rgba(255, 255, 255, 0.3)",
  },

  balanceInnerRight: {
    flex: "1",
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    "& b": {
      color: "#ffffff",
      fontSize: "14px",
      fontWeight: "600",
    }
  },
});
